module.exports = __webpack_public_path__ + "static/media/BlueHead.c7401ecc.png";